import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { AuthImage } from "@/components/AuthImage";
import { Camera } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Training photos shared by coaches for the sessions this parent's children attend. */
export const SessionPhotosCard = () => {
  const [photos, setPhotos] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/media/my-session-photos`, { params: { limit: 12 } });
        setPhotos(res.data?.files || []);
      } catch (err) {
        setPhotos([]);
      }
    };
    load();
  }, []);

  if (photos.length === 0) return null;

  return (
    <Card className="bg-slate-900/60 border-slate-800 mb-6" data-testid="session-photos-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base md:text-lg">
          <Camera className="w-5 h-5 text-cyan-400" /> Training photos
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3">
          {photos.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => setOpen(p)}
              className="rounded-lg overflow-hidden border border-slate-800 hover:border-cyan-500/60 transition-colors"
              data-testid={`session-photo-${p.id}`}
            >
              <AuthImage
                src={`${API}/media/${p.id}/raw`}
                alt={p.caption || p.title}
                className="h-24 w-full object-cover"
              />
            </button>
          ))}
        </div>
      </CardContent>

      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="bg-slate-900 border-slate-700 max-w-2xl" data-testid="session-photo-dialog">
          {open && (
            <div className="space-y-3">
              <AuthImage
                src={`${API}/media/${open.id}/raw`}
                alt={open.caption || open.title}
                className="w-full max-h-[60vh] object-contain rounded-lg bg-slate-950"
              />
              <div className="text-sm text-slate-300">
                <p className="font-medium text-white">{open.session_name || "Training"}</p>
                {open.caption && <p>{open.caption}</p>}
                {open.session_date && <p className="text-xs text-slate-500">{open.session_date}</p>}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </Card>
  );
};

export default SessionPhotosCard;
